/**
 * Quote domain schemas — canonical shape for TMS quote records.
 */
import { z } from 'zod';

export const QUOTE_STATUS = Object.freeze({
  DRAFT:            'draft',
  PENDING_APPROVAL: 'pending_approval',
  SENT:             'sent',
  WON:              'won',
  LOST:             'lost',
  EXPIRED:          'expired',
});

export const QuoteStatusEnum = z.enum(Object.values(QUOTE_STATUS));

export const QuoteSchema = z.object({
  quoteId:          z.string().optional(),
  tenantId:         z.string(),
  status:           QuoteStatusEnum,
  customerName:     z.string().min(1).max(200).optional(),
  originCity:       z.string().optional(),
  originState:      z.string().optional(),
  destinationCity:  z.string().optional(),
  destinationState: z.string().optional(),
  equipment:        z.string().optional(),
  mode:             z.string().optional(),
  quotedRate:       z.number().nonnegative().optional(),
  marketRate:       z.number().nonnegative().optional(),
  fuelSurcharge:    z.number().nonnegative().optional(),
  accessorialTotal: z.number().nonnegative().optional(),
  totalCharges:     z.number().nonnegative().optional(),
  marginPercent:    z.number().optional(),
  marginDollar:     z.number().optional(),
  expiryDate:       z.string().optional(),
  createdAt:        z.string().optional(),
  updatedAt:        z.string().optional(),
}).passthrough();
